<template>
  <v-app>
    <TheNavBar @menuClick="() => filtersOpen = !filtersOpen" />

    <v-navigation-drawer
      v-if="showFilterDrawer"
      v-model="filtersOpen"
      temporary
    >
      <MetadataFilters :filterMap :filterPropertyKeys @filterChange="catchFilterChange" />
    </v-navigation-drawer>

    <v-main>
      <RouterView />
    </v-main>
  </v-app>
</template>

<script setup lang="ts">
import { RouterView, useRoute } from 'vue-router'
import TheNavBar from '@/components/TheNavBar.vue'
import { useMetadataStore } from '@/stores/metadataStore'
import { computed, shallowRef, watch } from 'vue'
import MetadataFilters from '@/components/MetadataFilters.vue'
import { useDisplay } from 'vuetify'

const route = useRoute()
const mStore = useMetadataStore()

const filtersOpen = shallowRef(false)

// don't call the fetch of the metadata here, because it's
// being loaded in TheMap component
mStore.fetchGeoJSON()

const filterMap = computed(() => mStore.filterMap)
const filterPropertyKeys = computed(() => mStore.filterPropertyKeys)

const showFilterDrawer = computed(() => {
  const display = useDisplay();
  return display.smAndDown.value;
})

const catchFilterChange = (filterItem: ActiveFilterItem) => {
  mStore.changeFilter(filterItem);
}

/**
 * Watcher on the route to make sure anywhere from the app the id can be set
 * in the route and the popup shows up
 */
watch(
  () => route.params,
  (newParams) => {
    if (newParams?.id) {
      mStore.selectRecord(newParams.id as string)
    } else {
      mStore.clearSelection()
    }
  },
  { immediate: true }
)
</script>

<style scoped></style>
